export default __webpack_public_path__ + "static/media/tutorial05.9d937f02.jpg";